import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentSection, setCurrentSection] = useState('Home');
  const location = useLocation();

  // Update page title based on current section or route
  usePageTitle(currentSection);

  useEffect(() => {
    // Set current section based on route
    const path = location.pathname;
    if (path === '/') {
      setCurrentSection('Home');
    } else if (path === '/product') {
      setCurrentSection('Product');
    } else if (path === '/gallery') {
      setCurrentSection('Gallery');
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
        // Only track scroll sections on home page
        if (location.pathname === '/') {
          // Determine current section based on scroll position
          const sections = ['home', 'about', 'services', 'products', 'partners', 'contact'];
          const currentPos = window.scrollY + 100;        for (let section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const offsetTop = element.offsetTop;
            const offsetHeight = element.offsetHeight;
            
            if (currentPos >= offsetTop && currentPos < offsetTop + offsetHeight) {
              const sectionName = section.charAt(0).toUpperCase() + section.slice(1);
              setCurrentSection(sectionName);
              break;
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once to set initial state
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location]);

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
      
      // Update current section immediately when clicking
      const sectionName = sectionId.charAt(0).toUpperCase() + sectionId.slice(1);
      setCurrentSection(sectionName);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-brand">
          <img src="/images/logos/tritunasfull.png" alt="Tritunas" className="brand-logo" />
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><button onClick={() => scrollToSection('about')}>About</button></li>
            <li><button onClick={() => scrollToSection('services')}>Services</button></li>
            {/* Removed the Products button that scrolls to home section */}
            <li><button onClick={() => scrollToSection('partners')}>Partners</button></li>
            <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            <li><Link to="/product" onClick={() => setIsMenuOpen(false)}>Product</Link></li>
            <li><Link to="/gallery" onClick={() => setIsMenuOpen(false)}>Gallery</Link></li>
          </ul>
        </nav>

        <button 
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;